import React from 'react';
import { Form } from "react-bootstrap";

import { Field } from "../../utils/components/form";
import { InputError } from "./InputError";

export const InputField = (props) => {
  const { name, type, label, className, invisible, withLabel, maxLength, validate, ...attributes } = props;
  const inputClass = className || "";
  let divClass = invisible ? "invisible" : "w-100";
  if (withLabel) divClass = "d-flex align-items-center mb-one";

  return <div className={divClass}>
    {withLabel
      ? <label className="fs-5 text-gray pe-one" htmlFor={name}>
        {label}
      </label>
      : null
    }
    <Field
      name={name}
      validate={validate}
      {...attributes}
    >
      {({ input, meta }) => {
        return (
          <>
            <Form.Control
              className={(inputClass ? inputClass : "") + (meta && meta.error && !meta.modified ? " is-invalid" : "")}
              {...input}
              {...attributes}
              tabIndex="0"
              size="lg"
              isInvalid={meta && meta.touched && meta.error}
              isValid={meta && meta.touched && !meta.error}
              maxLength={maxLength}
              type={type || "text"}
              placeholder={label}
            />
            <InputError meta={meta} />
          </>
        );
      }}
    </Field>
  </div>;
};
